// Function index:
//   AdminPanelCtx — shared state every panel renderer needs: the
//                   current user, error/info setters that drive the
//                   header strip in admin.ts.
//   esc(s)        — html-attr-safe text escape (also escapes < and >
//                   for use inside elements).

import type { AuthUser } from '../../api.js';

export interface AdminPanelCtx {
  user: AuthUser;
  setError: (msg: string) => void;
  setInfo: (msg: string) => void;
}

export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
